"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// React
const deepmerge_1 = __importDefault(require("deepmerge"));
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const next12_utils_common_1 = require("@gcloud-npm/next12.utils.common");
const next12_adabyron_telco_client_get_my_data_1 = __importDefault(require("@gcloud-npm/next12.adabyron.telco.client.get-my-data"));
const next12_utils_environment_1 = require("@gcloud-npm/next12.utils.environment");
const next12_app_controller_reducers_sagas_main_reducer_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer");
const next12_utils_context_1 = require("@gcloud-npm/next12.utils.context");
const next12_app_controller_reducers_sagas_custo_reducer_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.custo-reducer");
const utils_1 = require("./utils");
const normalizer_1 = require("./ccli/normalizer");
const filePath = "route-handler-n";
const EVENT_TYPES = {
    VIEW: "view",
    LOADED: "printed",
};
function makeUpCustoParams(context, onDone) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const commonModule = yield Promise.resolve().then(() => __importStar(require("@gcloud-npm/next12.utils.common")));
            const urlParams = commonModule.getUrlParams(true, [
                /recomEnterprise/g,
                /percentile/g,
                /levCode/g,
                /prodCode/g,
                /promoCode/g,
                /ctz_c/g,
                /turingDev/g,
                /productOffering/g,
                /webCode/g,
                /context.*/g,
                /custoHost/g,
                /businessClusters/g,
                /recomType/g,
                /userType/g,
                /ctzTest/g,
            ]);
            const { subseg, gwIspI3D, gwIsp, userType, clientIDs, device, i3Ready, pageSegment, userPriority, creativitiesHistory, referalAP, userCUCFijoHash, userCUCMovilHash, userIdPartyHash, } = context;
            let custoObject = {
                i3Ready,
                SEG_NAV: pageSegment,
                i3_cuc: userCUCFijoHash,
                i3_cucm: userCUCMovilHash,
                i3_idp: userIdPartyHash,
                ga: clientIDs.ga,
                pageId: clientIDs.pageId,
                paid: clientIDs.sessId,
                ctz_c: "true",
                originUrl: window.location.href,
                context: {
                    subseg,
                    creativitiesHistory,
                    gw_isp: gwIsp,
                    gw_isp_d: gwIspI3D,
                    isLogado: userType ? "true" : "false",
                    tipoUsuario: userType,
                    deviceType: device,
                    seg_nav: pageSegment,
                    isPriority: userPriority ? "true" : "false",
                    referal_ap: referalAP,
                },
            };
            if (urlParams.context && typeof urlParams.context === "object") {
                urlParams.context = Object.assign(Object.assign({}, custoObject.context), urlParams.context);
            }
            custoObject = Object.assign(Object.assign({}, custoObject), urlParams);
            onDone(custoObject);
        }
        catch (e) {
            throw new Error(e);
        }
    });
}
function getHashesMerged({ hashes }) {
    let ICip3gHashes = {};
    try {
        let XCOL = (0, next12_utils_common_1.getCookie)("XCOL");
        XCOL = XCOL.split(".")[1];
        const atob = window.atob(XCOL);
        ICip3gHashes = JSON.parse(atob);
        ICip3gHashes = (0, utils_1.composeI3Object)(ICip3gHashes);
    }
    catch (err) {
        // cookie mal formada
    }
    return (0, utils_1.mergeIp3gHashes)(ICip3gHashes, hashes);
}
class RouteHandler extends react_1.Component {
    constructor() {
        super(...arguments);
        this.getContextSeoInfo = () => {
            const { currentSeo } = this.props;
            return {
                contextSeoMeta: currentSeo && currentSeo.description,
                pageName: currentSeo && currentSeo.page_name,
                productName: currentSeo && currentSeo.product_name,
            };
        };
        this.createInitialContextObj = () => {
            const { throwSonda } = this.props;
            let initialContextData = {};
            try {
                const timeStamp = Date.now();
                const pageSegment = (0, next12_utils_context_1.getSegment)();
                (0, utils_1.setSegmentCookie)(pageSegment, throwSonda);
                // Creating first context structure
                // Seteamos la primera versión de la estructura.
                initialContextData = Object.assign({ numLocationChanges: 0, infoRecom: null, eventType: EVENT_TYPES.VIEW, servicesReady: {}, tabId: (0, utils_1.getTabId)(), pageWebCode: null, pageName: null, pageWebName: null, pageProductCode: null, pageProductName: null, clientIDs: {
                        ga: (0, next12_utils_common_1.getCookie)("_ga"),
                        pageId: (0, utils_1.generatePageId)(),
                        sessId: (0, next12_utils_common_1.getCookie)("_mc_sessid"),
                    }, userAgent: window.navigator.userAgent, userType: "", infoContextApiFailed: false, managerInfo: null, isWebView: (0, utils_1.isNovum)(throwSonda), userConsentCookieOneTrust: null, pageSegment, contextURL: window.location.href, subseg: false, userPriority: false, gwIsp: (0, next12_utils_common_1.getCookie)("gwIsp"), gwIspI3D: (0, next12_utils_common_1.getCookie)("gwIsp_i3_d"), device: (0, next12_utils_common_1.getDeviceKindDependsOnViewPort)(), contextSeoMeta: null, i3Ready: timeStamp, pageInfoReady: false, referalAP: (document && document.referrer) || "", environment: (0, next12_utils_environment_1.findOutEnv)("movistar.es"), testVersion: null, testName: null, testDisable: null, networkParams: Object.assign({}, (0, utils_1.calculateNetworkParams)()), version: `${process.env.NEXT_PUBLIC_VERSION_JS}` || "unknown" }, this.getContextSeoInfo());
                return initialContextData;
            }
            catch (error) {
                const { throwSonda } = this.props;
                throwSonda({
                    kind: "FATAL",
                    processName: "createInitialContextObj",
                    filePath,
                    error,
                });
                return initialContextData;
            }
        };
        this.getClientInfoFromApi = ({ setCustoParams, setContextData, pageLoadedFunction, context, throwSonda, }) => __awaiter(this, void 0, void 0, function* () {
            const envName = context.environment.name;
            const maybeMocked = (0, utils_1.getMockedContext)(envName);
            const contextWithPosibleMock = (0, deepmerge_1.default)(context, maybeMocked);
            let result = Object.assign(Object.assign({}, normalizer_1.DEFAULT_RESPONSE), { contextVars: {
                    userType: (0, utils_1.isTelcoBuyProcess)() || (0, utils_1.isTelcoSite)() ? "Telco" : "",
                    infoContextApiFailed: true,
                }, xCol4Hashes: getHashesMerged({ hashes: {} }) });
            try {
                let getInfoModule = yield Promise.resolve().then(() => __importStar(require("./ccli/")));
                getInfoModule = getInfoModule.default;
                let data = {};
                if (typeof window !== "undefined" &&
                    window.location.href.indexOf("prod.cms") === -1) {
                    data = yield getInfoModule({ context: contextWithPosibleMock });
                    data = (0, normalizer_1.normalizeInfoContexto)(data);
                }
                const { xCol4Hashes, contextVars } = data;
                result = {
                    xCol4Hashes: null,
                    contextVars,
                };
                const xCol4HashesFromApi = (0, utils_1.composeI3Object)(xCol4Hashes);
                // aqui los vamos a tener calculados con IC
                result.xCol4Hashes = getHashesMerged({
                    hashes: xCol4HashesFromApi,
                });
                result.contextVars = Object.assign({}, result.contextVars);
                /* -------------------------------------------------------------------------- */
                /*                         Enriquecimiento de la xCOL con servicioI3          */
                /* -------------------------------------------------------------------------- */
                // Enriquecemos cuando no tenemos idparty
                if (
                // Este if es solo para enriquecimiento de la XCOL en Logado Telco
                result &&
                    result.contextVars &&
                    result.contextVars.userType === "Telco" &&
                    !result.xCol4Hashes.userIdPartyHash &&
                    (0, utils_1.checkTcolApiAllowed)()) {
                    const initialDataChanged = Object.assign(Object.assign(Object.assign({}, contextWithPosibleMock), result.contextVars), { userType: "Telco" });
                    // Rwalizamos la promise para obtener más info
                    (0, next12_adabyron_telco_client_get_my_data_1.default)({
                        context: initialDataChanged,
                        idFront: "TC",
                        build: false,
                        allowRedirection: false,
                    }).then(({ xcol }) => {
                        const hashesFromMisDatos = (0, utils_1.tranformXcol2Ip3Hashes)(xcol);
                        // Redefinimos para cuando obtengo xcol de misDAtos
                        // comprobar y combinar...
                        result = Object.assign(Object.assign({}, result), { xCol4Hashes: Object.assign(Object.assign({}, result.xCol4Hashes), hashesFromMisDatos) });
                    });
                }
                else {
                    // si no hay que enriquecer con mis DAtos caigo aki
                    // Por este else pueden entrar no logados/legado/telco sin necesidad de enriquecer
                    const mocked = (0, utils_1.getMockedContext)(envName) || {};
                    result.contextVars = (0, deepmerge_1.default)(result.contextVars, mocked);
                }
            }
            catch (err) {
                // console.error(err);
                // PROCESO CUANDO CUANDO INFO CONTEXT DA ERROR
                throwSonda({
                    processName: "request/cli/getInfoContextFromCCLI",
                    severidad: "ERROR",
                    info: "El api infocontexto ha fallado",
                    context: contextWithPosibleMock,
                });
            }
            // HTERMOS TERMINADO DE MIRAR HASHES Y TAL AHORA EL EVENTO
            const loadedEvent = { eventType: EVENT_TYPES.LOADED };
            const newContext = Object.assign(Object.assign(Object.assign(Object.assign({}, context), result.contextVars), result.xCol4Hashes), loadedEvent);
            makeUpCustoParams(newContext, setCustoParams), setContextData(newContext);
            pageLoadedFunction(newContext, loadedEvent);
        });
        this.sendPageEvent = (context, eventObj) => {
            const { throwSonda, sendCmsEvent } = this.props;
            const newContext = Object.assign(Object.assign({}, context), eventObj);
            try {
                const metricsImport = Promise.resolve().then(() => __importStar(require("@gcloud-npm/next12.utils.metrics")));
                metricsImport.then((metrics) => {
                    const { createPageEventObject } = metrics;
                    const data = createPageEventObject(newContext);
                    // comportamiento para esperar a GTM
                    let interval = null;
                    let retries = 10;
                    const TIME_BETWEEN_RETRIES = 25;
                    if (`${process.env.NEXT_PUBLIC_GTM_USAGE}` === "true") {
                        interval = setInterval(() => {
                            if (window.dataLayerGTM) {
                                window.dataLayerGTM.push(data);
                                clearInterval(interval);
                            }
                            if (retries < 0) {
                                clearInterval(interval);
                                throwSonda({
                                    kind: "ERROR",
                                    processName: "sendPageEvent",
                                    filePath,
                                    info: "No se creó el array window.datalayerGTM",
                                });
                            }
                            retries = retries - 1;
                        }, TIME_BETWEEN_RETRIES);
                    }
                    else {
                        // apilamos sin problemas
                        sendCmsEvent(data);
                    }
                });
            }
            catch (error) {
                console.error(error);
                throwSonda({
                    kind: "FATAL",
                    processName: "sendPageEvent",
                    filePath,
                    error,
                });
            }
        };
    }
    componentDidMount() {
        const { setContextData, throwSonda, setCustoParams, setSCXStatus } = this.props;
        // construyo context inicial + seo y guardo en redux, envio el pageview
        const context = this.createInitialContextObj();
        Promise.resolve().then(() => __importStar(require("@gcloud-npm/next12.utils.ping-cms-page"))).then((pingModule) => {
            // ping a cms page
            pingModule = pingModule.default;
            let ping = new pingModule({ context });
            ping.sendPingCmsPage();
        });
        // envio pageView
        const viewEvent = { eventType: EVENT_TYPES.VIEW };
        this.sendPageEvent(context, { eventType: EVENT_TYPES.VIEW });
        setContextData(Object.assign(Object.assign({}, context), viewEvent));
        // llamo a info contexto, mando al finalizar el pageloaded
        this.getClientInfoFromApi({
            setCustoParams,
            setContextData,
            pageLoadedFunction: this.sendPageEvent,
            context,
            throwSonda,
        });
    }
    render() {
        return null;
    }
}
const mapStateToProps = (state) => ({
    currentSeo: state.main.currentSeo,
});
const mapDispatchToProps = (dispatch) => ({
    sendCmsEvent: (data) => dispatch(next12_app_controller_reducers_sagas_main_reducer_1.actions.sendCmsEvent(data)),
    setSCXStatus: (status) => dispatch(next12_app_controller_reducers_sagas_main_reducer_1.actions.setSCXStatus(status)),
    setContextData: (newData) => dispatch(next12_app_controller_reducers_sagas_main_reducer_1.actions.setContextData(newData)),
    throwSonda: (data) => dispatch(next12_app_controller_reducers_sagas_main_reducer_1.actions.throwSonda(data)),
    setCustoParams: (data) => dispatch(next12_app_controller_reducers_sagas_custo_reducer_1.actions.setCustoParams(data)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(RouteHandler);
//# sourceMappingURL=index.js.map